import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { object, func, bool, string } from 'prop-types';
import { isGigPaused } from '../../../utils/gigStatus';
import StudioBox from '../../StudioBox';
import PackagesTabs from '../../PackagesTabs';
import ContactSeller from '../../ContactSeller';
import GigStudioCard from '../../StudioCard';

const SidebarContent = ({
    customOrder,
    studio,
    onComparePackagesClick = _.noop,
    useStickyLayout,
    className = '',
    setRef = _.noop
}, { general }) => {

    const { isStudio, gigStatus, traffiqed, isLimitedEdition } = general;
    const isPaused = isGigPaused(gigStatus, traffiqed);
    const shouldRenderContactSeller = useStickyLayout && !isLimitedEdition;

    return (
        <aside className={classNames(className, 'sidebar-content')} ref={setRef}>

            {isStudio && <StudioBox/>}

            <PackagesTabs customOrder={customOrder} onComparePackagesClick={onComparePackagesClick}/>

            {shouldRenderContactSeller &&
            <ContactSeller customOrder={customOrder} isPaused={isPaused}/>}

            {!useStickyLayout && <GigStudioCard studio={studio}/>}

        </aside>
    );
};

SidebarContent.propTypes = {
    studio: object,
    customOrder: object,
    onComparePackagesClick: func,
    setRef: func,
    useStickyLayout: bool,
    className: string
};

SidebarContent.contextTypes = {
    general: object
};

export default SidebarContent;
